module.exports = __webpack_public_path__ + "static/media/lien.7b9624a4.png";